<template>
    <app-dialog
        v-if="valid"
        v-model="inputValue"
        :title="$t('it_looks_like_were_having_some_internal_issues')"
        :persistent="false"
        size="large"
        :cancel-button-text="$t('ignore')"
        :on-cancel-fn="() => (inputValue = false)"
        :continue-button-text="$t('send_report')"
        :on-continue-fn="() => send()"
        :hide-on-continue="false"
        :disabled="loading || (!options.comments && !form.comments)"
    >
        <v-card-text class="px-6">
            <p>
                {{ $t('weve_encountered_a_problem_processing_the_request_and_your_changes_have_not_been_saved') }}.
                {{ $t('our_technical_team_has_been_notified_of_the_problem') }}:
            </p>
            <transition appear name="fade" mode="out-in">
                <field-description
                    v-if="!options.comments"
                    v-model="form.comments"
                    :disabled="loading"
                    :label="$t('what_happened')"
                />
            </transition>
            <p class="mb-0">{{ $t('to_process_the_request_you_can_contact_us_with_the_details_of_the_request') }}.</p>
        </v-card-text>
    </app-dialog>
</template>

<script>
import config from '@/config';
import http from '@/lib/http';

export default {
    name: 'AppUserFeedback',
    components: {
        AppDialog: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppDialog'
            )
    },
    data: () => ({
        form: {
            name: null,
            email: null,
            comments: null
        },
        dsn: null,
        organisation_slug: null,
        project_slug: null,
        loading: false
    }),
    computed: {
        valid() {
            if (!this.dsn) {
                return false;
            }
            if (!this.organisation_slug) {
                return false;
            }
            if (!this.project_slug) {
                return false;
            }
            return true;
        },
        inputValue: {
            get() {
                return this.$store.getters['app/request_user_feedback_modal'];
            },
            set(v) {
                if (v) {
                    return this.$store.dispatch('app/showUserFeedbackModal', this.options);
                } else {
                    return this.$store.dispatch('app/hideUserFeedbackModal');
                }
            }
        },
        options() {
            return this.$store.getters['app/request_user_feedback_modal_options'];
        }
    },
    mounted() {
        this.dsn = config.SENTRY_DSN;
        this.organisation_slug = config.SENTRY_ORGANISATION_SLUG;
        this.project_slug = config.SENTRY_PROJECT_SLUG;
    },
    methods: {
        resetForm() {
            this.form = {
                name: null,
                email: null,
                comments: null
            };
        },
        async send() {
            this.loading = false;

            try {
                // eslint-disable-next-line max-len
                const url = `https://sentry.io/api/0/projects/${this.organisation_slug}/${this.project_slug}/user-feedback/`;

                if (this.valid) {
                    await http.request({
                        method: 'POST',
                        withCredentials: false,
                        url,
                        data: {
                            event_id: this.options.event_id,
                            name: this.options.name || this.form.name,
                            email: this.options.email || this.form.email,
                            comments: this.options.comments || this.form.comments
                        },
                        headers: {
                            Authorization: 'DSN ' + this.dsn
                        }
                    });
                }

                this.inputValue = false;
                this.resetForm();
            } catch (error) {
                this.inputValue = false;
                this.resetForm();
            }

            this.loading = false;
        }
    }
};
</script>
